module.exports = __webpack_public_path__ + "img/tpc-web-2.d504690a.jpg";